import PropTypes from "prop-types"

export default function Classification({ classification }) {
  const { name } = classification ?? {}
  if (!name) {
    return null
  }
  return <div className="classification">{name}</div>
}

Classification.propTypes = {
  classification: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
}
